export enum BonLivraisonApiErrorCodes {
  BonLivraisonNotFound = 4044
}
